
/* 移动端页面 */
import _import from './_import'

const MobileHome = _import('mobile/Home')
const TaskList = _import('mobile/aiptTask/List')
const TaskDetail = _import('mobile/aiptTask/Detail')
const PhotoSameScreenUploader = _import('mobile/photoSameScreenUploader/index')


export default [

  {
    path: '/mobile',
    name: 'mobile',
    redirect: '/mobile/tasklist',
    component: MobileHome,
    meta: {isMobile: true, title: '首页'},
    children: [
      {
        path: 'tasklist',
        name: 'taskList',
        component: TaskList,
        meta: {isMobile: true, keepAlive: true, title: '任务列表'}, 
      },
      {
        path: 'taskdetail/:taskId',
        name: 'taskDetail',
        component: TaskDetail,
        meta: {isMobile: true, title: '任务详情'},
      },
      {
        path: '/photoSameScreenUploader',
        name: 'photoSameScreenUploader',
        component: PhotoSameScreenUploader,
        meta: {isMobile: true, title: '拍照同屏上传'},
      },
      
    ]
  },
  
]